interface UpdateItem {
  date: string;
  title: string;
  description: string;
  tag: string;
}

const updates: UpdateItem[] = [
  {
    date: '2026.07.30',
    title: '《奔跑吧》最新季上线',
    description: '跑男团全新阵容集结出发，首期节目户外挑战精彩纷呈，高清版现已同步更新。',
    tag: '新季上线',
  },
  {
    date: '2026.07.28',
    title: '《脱口秀大会》第六季热播中',
    description: '新老脱口秀演员同台竞技，首轮淘汰赛金句频出，爆笑片段不容错过。',
    tag: '热播推荐',
  },
  {
    date: '2026.07.25',
    title: '《向往的生活》收官特别篇',
    description: '本季田园生活完美收官，温馨治愈的特别篇带来满满感动，全季高清合集上线。',
    tag: '收官推荐',
  },
  {
    date: '2026.07.22',
    title: '平台画质全面升级',
    description: '天天影视全站综艺节目支持超清画质，智能码率技术带来更流畅的观看体验。',
    tag: '平台动态',
  },
  {
    date: '2026.07.18',
    title: '《中餐厅》新一季海外特辑',
    description: '中餐厅团队开启全新海外之旅，异国美食与中国味道的碰撞，高清同步更新中。',
    tag: '美食综艺',
  },
  {
    date: '2026.07.15',
    title: '暑期综艺追看指南上线',
    description: '天天影视整理暑期必看综艺清单，热门真人秀、搞笑综艺一网打尽，陪你度过精彩夏天。',
    tag: '编辑推荐',
  },
  {
    date: '2026.07.10',
    title: '《密室大逃脱》新密室挑战',
    description: '明星嘉宾勇闯全新密室主题，烧脑解谜与团队协作升级，精彩刺激不容错过。',
    tag: '悬疑推理',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide mb-3">
            最新动态
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 mb-3">
            综艺更新快讯
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            第一时间了解天天影视的最新综艺更新和平台动态
          </p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-[19px] md:left-6 top-0 bottom-0 w-0.5 bg-background-300/60 hidden sm:block"></div>

          <div className="space-y-0">
            {updates.map((item, idx) => (
              <div key={idx} className="relative flex gap-4 md:gap-6 pb-8 last:pb-0">
                {/* Timeline dot */}
                <div className="hidden sm:flex w-12 shrink-0 justify-center relative z-10">
                  <div className="w-3 h-3 rounded-full bg-primary-500 mt-1.5 ring-4 ring-background-50"></div>
                </div>

                <div className="flex-1 bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/70 transition-all duration-300 hover:border-primary-200">
                  <div className="flex items-center gap-2 flex-wrap mb-2">
                    <span className="text-xs font-mono text-foreground-500">{item.date}</span>
                    <span className="bg-accent-100 text-accent-800 text-xs px-2 py-0.5 rounded-full whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-base font-bold text-foreground-900 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}